<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>
        <select
            :value="value"
            class="wf-input"
            :class="{ 'wf-input--error': error }"
            @change="emitValue($event.target.value)"
        >
            <option value="" disabled selected>{{ label }}</option>
            <option
                v-for="(option, index) in options"
                :key="index"
                :value="option"
            >
                {{ option }}
            </option>
        </select>
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import FieldMixin from './FieldMixin'

export default {
    name: 'SelectField',
    mixins: [FieldMixin],
    computed: {
        options() {
            if (!this.attribute.config || !this.attribute.config.options) return []
            return this.attribute.config.options[this.locale] || this.attribute.config.options['fr'] || []
        }
    }
}
</script>
